module.exports = __webpack_public_path__ + "p1_img2.jpg?1602bed43a84f60ace81bc232fbdca33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img2.jpg
// module id = 49
// module chunks = 0